import React, { useEffect, useState, useMemo, Fragment } from 'react'
import { Box, List, ListItemButton, ListItemText } from '@mui/material'
import { useOutletContext } from 'react-router-dom'
import { toast } from 'react-toastify'
import Toolbar from '../../toolbar/Toolbar'
import Form from '../../form/Form'
import { getObjects } from '../../../api/apiClientCrud'
import { useAuth } from '../../../context/AuthContext'

function SuperAdmin() {
  const userRight = useOutletContext()
  const { user } = useAuth()
  const [selectedIndex, setSelectedIndex] = useState(0)
  const [data, setData] = useState({ lines: [] })
  const [file, setFile] = useState()

  const tables = useMemo(
    () => [
      {
        name: 'status',
        label: 'Statuts',
        columns: [
          { label: 'id', name: 'id', type: 'text', enableEditing: false },
          { label: 'status', name: 'status', type: 'text', enableEditing: true },
          { label: 'object', name: 'object', type: 'text', enableEditing: true },
          { label: 'order', name: 'order', type: 'text', enableEditing: true },
          { label: 'is_list', name: 'is_list', type: 'checkbox' },
          { label: 'status_code', name: 'status_code', type: 'text', enableEditing: true },
          { label: 'color', name: 'color', type: 'text', enableEditing: true },
          { label: 'createdBy', name: 'createdBy', type: 'text', enableEditing: true },
          { label: 'createdDateDime', name: 'createdDateDime', type: 'datetime', enableEditing: true },
          { label: 'lastModBy', name: 'lastModBy', type: 'text', enableEditing: true },
          { label: 'lastModDateTime', name: 'lastModDateTime', type: 'datetime', enableEditing: true }
        ]
      },
      {
        name: 'classifications',
        label: 'Classifications',
        columns: [
          { label: 'id', name: 'id', type: 'text', enableEditing: false },
          { label: 'name', name: 'name', type: 'text', enableEditing: true },
          { label: 'label', name: 'label', type: 'text', enableEditing: true },
          { label: 'type', name: 'type', type: 'text', enableEditing: true },
          { label: 'max', name: 'max', type: 'text', enableEditing: true },
          { label: 'createdBy', name: 'createdBy', type: 'text', enableEditing: true },
          { label: 'createdDateDime', name: 'createdDateDime', type: 'datetime', enableEditing: true },
          { label: 'lastModBy', name: 'lastModBy', type: 'text', enableEditing: true },
          { label: 'lastModDateTime', name: 'lastModDateTime', type: 'datetime', enableEditing: true }
        ]
      },
      {
        name: 'modules',
        label: 'Modules',
        columns: [
          { label: 'id', name: 'id', type: 'text', enableEditing: false },
          { label: 'module', name: 'module', type: 'text', enableEditing: true },
          { label: 'is_access', name: 'is_access', type: 'checkbox' },
          { label: 'is_list', name: 'is_list', type: 'checkbox' },
          { label: 'is_view', name: 'is_view', type: 'checkbox' },
          { label: 'is_edit', name: 'is_edit', type: 'checkbox' },
          { label: 'is_add', name: 'is_add', type: 'checkbox' },
          { label: 'is_delete', name: 'is_delete', type: 'checkbox' },
          { label: 'is_quantity', name: 'is_quantity', type: 'checkbox' },
          { label: 'is_free_account', name: 'is_free_account', type: 'checkbox' },
          { label: 'createdBy', name: 'createdBy', type: 'text', enableEditing: true },
          { label: 'createdDateDime', name: 'createdDateDime', type: 'datetime', enableEditing: true },
          { label: 'lastModBy', name: 'lastModBy', type: 'text', enableEditing: true },
          { label: 'lastModDateTime', name: 'lastModDateTime', type: 'datetime', enableEditing: true }
        ]
      },
      {
        name: 'categories',
        label: 'Categories',
        columns: [
          { label: 'id', name: 'id', type: 'text', enableEditing: false },
          {
            label: 'company_id',
            name: 'company_id',
            type: 'text',
            enableEditing: false,
            defaultValue: () => user.company_id
          },
          { label: 'name', name: 'name', type: 'text', enableEditing: true },
          { label: 'slug', name: 'slug', type: 'text', enableEditing: true },

          { label: 'isActive', name: 'isActive', type: 'checkbox' },

          { label: 'createdBy', name: 'createdBy', type: 'text', enableEditing: true },
          { label: 'createdDateDime', name: 'createdDateDime', type: 'datetime', enableEditing: true },
          { label: 'lastModBy', name: 'lastModBy', type: 'text', enableEditing: true },
          { label: 'lastModDateTime', name: 'lastModDateTime', type: 'datetime', enableEditing: true }
        ]
      },
      {
        name: 'globalAttribute',
        label: 'Attributs',
        columns: [
          { label: 'id', name: 'id', type: 'text', enableEditing: false },
          {
            label: 'company_id',
            name: 'company_id',
            type: 'text',
            enableEditing: false,
            defaultValue: () => user.company_id
          },
          { label: 'category', name: 'category', type: 'text', enableEditing: true },
          { label: 'label', name: 'label', type: 'text', enableEditing: true },
          { label: 'value', name: 'value', type: 'text', enableEditing: true },
          { label: 'baseCost', name: 'baseCost', type: 'float', enableEditing: true },
          { label: 'isAvailable', name: 'isAvailable', type: 'checkbox', enableEditing: true },

          {
            label: 'Image',
            name: 'image',
            type: 'image',
            enableEditing: false,
            file: (data) => {
              // Prendre le dernier attachment image (le plus récent après upload)
              const images = data.attachments?.filter((a) => a.type === 'image') ?? []
              const lastImage = images[images.length - 1]
              if (lastImage) {
                if (lastImage.url) return lastImage.url
                else if (lastImage.file) return lastImage
              }
              return null
            }
          },
          { label: 'Upload', name: 'attachments', type: 'file', enableEditing: true }
        ],
        options: {
          fileParentType: 'globalAttribute'
        }
      }
    ],
    []
  )

  const toolbar = useMemo(
    () => ({
      accessRight: userRight,
      objectType: 'tables',
      title: tables[selectedIndex].label,
      modelType: tables[selectedIndex].name,
      actions: { audits: true }
    }),
    [userRight, selectedIndex, tables]
  )

  const options = useMemo(
    () => ({
      apiName: tables[selectedIndex].name,
      formStyle: { width: '100%' },
      noButton: true,
      fields: [
        [
          {
            name: 'lines',
            label: 'Lignes',
            type: 'mytable',
            tableOptions: {
              paperStyle: { width: '100%' },
              object: `tables/${tables[selectedIndex].name}`,
              columns: tables[selectedIndex].columns,
              data: data.lines,
              setDataParent: setData,
              title: '',
              components: { Container: Fragment },
              options: {
                ...tables[selectedIndex].options,
                pageSize: 5,
                search: false,
                paging: true,
                actionsColumnIndex: 0
              },
              actions: { add: true, edit: true, delete: { message: 'Voulez-vous vraiment supprimer la ligne' } }
            }
          }
        ]
      ],
      data
    }),
    [selectedIndex, tables, data]
  )

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await getObjects(`tables/${tables[selectedIndex].name}`)
        setData({ lines: res.data.rows })
      } catch (err) {
        toast.error('Erreur lors du chargement de la table', { autoClose: 2000 })
      }
    }
    fetchData()
  }, [selectedIndex, tables])

  useEffect(() => {
    if (data.file) {
      // Si on est déjà en train de gérer des lignes dans le tableau,
      // il ne faut PAS écraser l'objet data brutalement.
      const newPreviews = Array.from(data.file).map((f) => ({
        type: 'image',
        file: f,
        isPreview: true
      }))

      setData((prev) => ({
        ...prev,
        // ON NE TOUCHE PAS à prev.lines ici si elles existent déjà
        attachments: [...(prev.attachments || []).filter((a) => !a.isPreview), ...newPreviews],
        file: undefined
      }))
      setFile(data.file)
    }
  }, [data.file]) // Ne surtout pas ajouter 'data' dans les dépendances ici !

  return (
    <Box
      sx={{ display: 'flex', flexDirection: 'column', height: 'calc(100vh - 65px)', overflowY: 'auto', flexGrow: 1 }}
    >
      <Box sx={{ display: 'grid', gridAutoColumns: '1fr' }}>
        <List sx={{ gridRow: '1' }}>
          {tables.map((table, index) => (
            <ListItemButton key={table.name} selected={selectedIndex === index} onClick={() => setSelectedIndex(index)}>
              <ListItemText primary={table.label} />
            </ListItemButton>
          ))}
        </List>

        <Box sx={{ gridRow: '1', gridColumn: 'span 7' }}>
          <Toolbar options={toolbar} />
          <Form mode='edit' modeProps='noButton' options={options} setDataParent={setData} />
        </Box>
      </Box>
    </Box>
  )
}

export default SuperAdmin
